export default __webpack_public_path__ + "static/media/Tabs.6079ddb3.svg";